import * as types from './types';
import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { toastInfo } from 'Common/ToastHelper';
import { has } from 'lodash';

export const getInitialData = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ID_CARDS_FETCHING, true));

    try {
      const url = `student/teacher/${siteId}`;
      const teachers = await MPWWebApi.getGeneric(url);

      dispatch({
        type: types.ID_CARDS_GET_DATA,
        payload: {
          teachers: teachers.data.Data,
        },
      });
    } catch (error) {
      dispatch({
        type: types.ID_CARDS_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.ID_CARDS_FETCHING, false));
  };
};

export const getReport = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ID_CARDS_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/idcards',
        model
      );

      if (
        !response.data.Data ||
        response.data.Data.toUpperCase().includes('NO DATA')
      ) {
        toastInfo('No data found!');
      } else {
        dispatch({
          type: types.ID_CARDS_GET_REPORT,
          payload: response.data.Data,
        });
      }
    } catch (error) {
      if (has(error, 'response.data.Errors')) {
        dispatch({
          type: types.ID_CARDS_FETCH_ERROR,
          payload: error.response.data.Errors,
        });
      }
    }

    dispatch(loading(types.ID_CARDS_FETCHING, false));
  };
};

export const getGrades = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.ID_CARDS_FETCHING, true));
      const response = await MPWWebApi.getGeneric('grade');
      dispatch(success(types.ID_CARDS_FETCH_GRADES, response.data.Data));
    } catch (error) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching grades.',
      };

      dispatch(
        handleErrorException(error, types.ID_CARDS_FETCH_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.ID_CARDS_FETCHING, false));
    }
  };
};

export const clearReport = () => {
  return {
    type: types.ID_CARDS_CLEAR_REPORT,
  };
};

export const clearErrors = () => {
  return {
    type: types.ID_CARDS_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/idcards/state/idcards/actions.js